

const siteConfig = {
    apiUrl : 'https://api.mccoymart.com/seller',
    image_url : 'https://api.mccoymart.com/seller/get_image/?image=',
    b2bUrl : 'https://api.mccoymart.com/b2b'
}

export default siteConfig;
